export const ProfileConstant = {
    
    PROFILE_UPDATE_API: "/vendor",


};
